import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, Fragment as _Fragment, createElementVNode as _createElementVNode, renderSlot as _renderSlot, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center" }
const _hoisted_2 = { class: "relative flex w-full justify-end gap-2" }
const _hoisted_3 = {
  key: 0,
  class: "absolute -left-[45px] -top-[45px] z-50 rounded-full border border-gray-300 bg-emerald-50 p-1 shadow"
}
const _hoisted_4 = {
  key: 1,
  class: "text-md flex-1 font-medium text-gray-800"
}
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_7 = { class: "rounded bg-gray-50 px-1.5 py-0.5 text-xs ring-1 ring-gray-300 focus:ring-2 focus:ring-opacity-50" }

import { computed, type HTMLAttributes, type PropType, type VNodeProps } from 'vue';
import { PencilAltIcon, TrashIcon } from '@heroicons/vue/outline';
import { Handle, Position } from '@vue-flow/core';
import { NodeToolbar } from '@vue-flow/node-toolbar';
import { PlusIcon } from '@heroicons/vue/solid';
import store from '@/store';
import { ConnectFlowModelingActions, ConnectFlowModelingGetters } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiNode',
  props: {
    title: {
        type: String,
    },
    icon: {
        type: Function as PropType<HTMLAttributes & VNodeProps>,
    },
    text: {
        type: String,
        default: '',
    },
    nodeId: {
        type: String,
        required: true,
    },
    showActions: {
        type: Boolean,
        default: false,
    },
    noEdition: {
        type: Boolean,
        default: false,
    },
    showHandleTarget: {
        type: Boolean,
        default: true,
    },
    showHandleSource: {
        type: Boolean,
        default: true,
    },
    bgColor: {
        type: String,
    },
    borderColor: {
        type: String,
    },
    roundedStyle: {
        type: String,
    },
    padding: {
        type: String,
    },
    nodeWidth: {
        type: String,
    },
    nodeHeight: {
        type: String,
    },
    hideNodeId: {
        type: Boolean,
    },
},
  emits: ['editNode', 'removeNode'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const handleEditClick = () => {
    emit('editNode');
};

const handleRemoveClick = () => {
    emit('removeNode');
};

function openComponentSelector() {
    store.dispatch('flow/' + ConnectFlowModelingActions.SET_MENU, {
        show: true,
        idTriggerBy: props.nodeId,
    });
}

const node = computed(() =>
    store.getters['flow/' + ConnectFlowModelingGetters.ELEMENT_BY_ID](props.nodeId),
);

return (_ctx: any,_cache: any) => {
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _mergeProps(_ctx.$attrs, {
      class: [
                __props.bgColor ? __props.bgColor : 'bg-gray-50',
                __props.borderColor ? __props.borderColor : 'border-gray-300',
                __props.roundedStyle ? __props.roundedStyle : 'rounded',
                __props.padding ? __props.padding : 'px-4 py-4',
                __props.nodeWidth ? __props.nodeWidth : 'w-[350px]',
                __props.nodeHeight ? __props.nodeHeight : 'h-auto',
                'relative border-2 shadow',
            ]
    }), [
      _createElementVNode("div", _hoisted_2, [
        (__props.icon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), {
                class: "text-secondary h-9 w-9",
                "aria-hidden": "true"
              }))
            ]))
          : _createCommentVNode("", true),
        (__props.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.title), 1))
          : _createCommentVNode("", true),
        (__props.showActions)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (!__props.noEdition)
                ? _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                    key: 0,
                    variant: "primary",
                    onClick: handleEditClick
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(PencilAltIcon), { class: "h-5 w-5" })
                    ]),
                    _: 1
                  })), [
                    [_directive_tippy, _ctx.$t('core.actions.Edit')]
                  ])
                : _createCommentVNode("", true),
              _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                variant: "danger",
                onClick: handleRemoveClick
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                ]),
                _: 1
              })), [
                [_directive_tippy, _ctx.$t('core.actions.Remove')]
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (__props.showHandleTarget)
        ? (_openBlock(), _createBlock(_unref(Handle), {
            key: 0,
            type: "target",
            position: _unref(Position).Top
          }, null, 8, ["position"]))
        : _createCommentVNode("", true),
      (__props.showHandleSource)
        ? (_openBlock(), _createBlock(_unref(Handle), {
            key: 1,
            type: "source",
            position: _unref(Position).Bottom
          }, null, 8, ["position"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default"),
        (!__props.hideNodeId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, " #" + _toDisplayString(node.value.id), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 16),
    _createVNode(_unref(NodeToolbar), {
      class: "flex items-center gap-0.5",
      "is-visible": node.value?.connectable as boolean,
      position: _unref(Position).Bottom
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "border-1 hover:shadow-blueGray-600 rounded-full bg-gray-50 p-1 shadow",
          onClick: openComponentSelector
        }, [
          _createVNode(_unref(PlusIcon), { class: "h-5 w-5" })
        ])
      ]),
      _: 1
    }, 8, ["is-visible", "position"])
  ]))
}
}

})